import { ErrorHandler, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { of } from 'rxjs';
import { delay, first, takeUntil } from 'rxjs/operators';
import { AppStateService } from '../services';
import { AuthService } from '../services/auth.service';
// import * as Sentry from '@sentry/angular';

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
  constructor(
    private appStateService: AppStateService,
    private authService: AuthService,
    private translateService: TranslateService
  ) {
    super();
  }

  handleError(error: any): void {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    if (error.message && chunkFailedMessage.test(error.message)) {
      this.appStateService.navigateToError({
        severity: 'warn',
        message: this.translateService.instant(
          'Facebook tool has been modified. The page will be reload in 5 seconds'
        )
      });
      of(null)
        .pipe(first(), delay(5000), takeUntil(this.authService.redirectToVendor$))
        .subscribe(_ => {
          window.location.reload();
        });
    }
    super.handleError(error);
    // Sentry.captureException(error);
  }
}
